import { createFileRoute } from "@tanstack/react-router";
import { AdminCalendarPage } from "@/features/admin/calendar-review";

/** Global calendar review (ALP-73 API, console tab ALP-85): publish or reject an event for every organization. */
export const Route = createFileRoute("/admin/calendar")({
  head: () => ({ meta: [{ title: "Calendar review · Admin · Malfak" }] }),
  component: AdminCalendarPage,
});
